<template>
  <!-- <bread-crumb list-classes="breadcrumb-links breadcrumb-dark"> -->
  <bread-crumb list-classes="breadcrumb-links breadcrumb-light">
    <BreadCrumbItem>
        <router-link to="/">
          <i class="fas fa-home"></i>
        </router-link>
    </BreadCrumbItem>
    <BreadCrumbItem
      v-for="(route, index) in $route.matched.slice()"
      :key="route.name"
      :active="index === $route.matched.length - 1"
      style="display:inline-block"
    >
      <router-link
        :to="{ name: route.name }"
        v-if="index < $route.matched.length - 1"
      >
        {{ language_terms[route.name] }}
      </router-link>
      <span v-else>{{ language_terms[route.name] }}</span>
    </BreadCrumbItem>
  </bread-crumb>
</template>

<script>
  import { mapState } from "vuex";

  import BreadCrumb from './Breadcrumb';
  import BreadCrumbItem from './BreadcrumbItem';

  export default {
    name: 'route-breadcrumb',
    components: {
      BreadCrumb,
      BreadCrumbItem
    },
    methods: {
      getBreadName(route) {
        return route.name;
      }
    },
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge
         })
    }
  };
</script>

<style scoped></style>
